var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkFavStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50199 15.7502L5.24743 17.987C4.73822 18.2547 4.1084 18.0589 3.84069 17.5497C3.73409 17.3469 3.6973 17.1147 3.73603 16.8889L4.54858 12.1513L1.10656 8.79621C0.694602 8.39464 0.686172 7.73515 1.08774 7.32319C1.24764 7.15914 1.45716 7.05239 1.68387 7.01944L6.44061 6.32825L8.56789 2.0179C8.8225 1.50202 9.44711 1.2902 9.963 1.54481C10.1684 1.6462 10.3347 1.81247 10.4361 2.0179L12.5634 6.32825L17.3201 7.01944C17.8894 7.10217 18.2839 7.63076 18.2012 8.20007C18.1682 8.42678 18.0615 8.6363 17.8974 8.79621L14.4554 12.1513L15.268 16.8889C15.3652 17.4559 14.9844 17.9944 14.4174 18.0916C14.1916 18.1304 13.9593 18.0936 13.7566 17.987L9.50199 15.7502Z",
    stroke: "#70808F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkFavStar);
export default __webpack_public_path__ + "static/media/MarkFavStar.877d1718.svg";
export { ForwardRef as ReactComponent };